module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-10-svgrepo-com.f24c58ac.svg";